














































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel,DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import publicFunc from '../../common/util/publicFunc';
import { formRules } from '@/common/util/validator';
import { Kpi, yun } from '@/http';
import { enums } from '@/common/enums';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        SearchPanel,
        DraggerImg
    },
})
export default class carrierKPIDetail extends Vue {
    expireTimeOption = {
        // disabledDate(date) {
        //     //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
        //     return (
        //         date.getTime() < new Date(new Date().getFullYear(), 0, 1).getTime() ||
        //         date.getTime() > new Date(new Date().getFullYear(), 11, 31).getTime()
        //     );
        // },
    };
    public carrierName = '';
    selectList = [];
    selectCar1(data) {
        this.searchValue.carrierId = data.id;
    }
    async querySearch1(queryString, cb) {
        this.searchValue.carrierId = '';
        let res = await yun.GetCarrierList({ Name: queryString });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        this.selectList = result;
        cb(result);
    }

    public month = null;

    public back() {
        this.$router.back();
    }

    @Watch('month')
    public monthChange() {
        this.choosed();
    }

    public monthShow = null;
    async choosed() {
        if (this.month) {
            if (this.month[0] == this.month[1]) {
                this.monthShow = this.month[0] + '月';
            } else {
                this.monthShow = this.month[0] + '月-' + this.month[1] + '月';
            }

            console.log(this.month[0] + '月-' + this.month[1] + '月');
            let obj = { year: this.year, startMouth: this.month[0], endMouth: this.month[1] };
        } else {
            this.getMonth();
        }
    }
    public year = null;
    public async getMonth() {
        var myDate = new Date();
        this.monthShow = myDate.getMonth() + 1 + '月';
        this.year = myDate.getFullYear();
        let obj = { year: this.year, startMouth: myDate.getMonth() + 1, endMouth: myDate.getMonth() + 1 };
        console.log('obj' + obj);
    }

    public stateType = enums.stateType;
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public dialogVisible = false;
    public handleClose() {
        this.dialogVisible = false;
    }

    public searchValue: any = {
        KpiId: this.$route.query.id,
        startTime: '',
        endTime: '',
        cycle: '',
        carrierId: '',
        orderBy: '',
        isAsc: true,
    };

    public timeList = [];

    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('carrierKPIDetial', JSON.stringify(this.colData));
    }
    public colData = JSON.parse(localStorage.getItem('carrierKPIDetial'))
        ? JSON.parse(localStorage.getItem('carrierKPIDetial'))
        : [
              { title: '承运商', isShow: true, disabled: false },
              { title: '考核周期', isShow: true, disabled: false },
              { title: '发货及时率', isShow: true, disabled: false },
              { title: '报价及时率', isShow: true, disabled: false },
              { title: '回单及时率', isShow: true, disabled: false },
              { title: '产品货损', isShow: true, disabled: false },
              { title: '现场管理', isShow: true, disabled: false },
              { title: '满意度', isShow: true, disabled: false },
              { title: '综合得分', isShow: true, disabled: false },
              { title: '创建时间', isShow: true, disabled: false },
          ];

    public datetimerange(v) {
        if (v) {
            this.searchValue.startTime = v[0];
            this.searchValue.endTime = v[1];
        } else {
            this.searchValue.startTime = null;
            this.searchValue.endTime = null;
        }
    }

    public labelPosition: string = 'right';

    public async toDetail(row) {
        console.log('row' + JSON.stringify(row));
        let res = await Kpi.GetCarrierPortrait({ carrierId: row.carrierId });
        if (res) {
            this.$router.push({
                path: '/carrierPortrait',
                query: {
                    id: row.carrierId,
                },
            });
        } else {
            this.$alert('请先新增KPI考核');
        }
    }

    public $refs!: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        formData: HTMLFormElement;
    };

    public async exportExcel() {
        let data = await Kpi.Export(this.searchValue);
    }

    public searchFunc() {
        sessionStorage.setItem('CarrierKPIDetial_searchValue', JSON.stringify(this.searchValue));
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }
    public resetSearchValue() {
        this.searchValue = {
            startTime: '',
            endTime: '',
            cycle: '',
            orderBy: '',
            isAsc: true,
        };
        this.timeList = [];
        sessionStorage.setItem('CarrierKPIDetial_searchValue', JSON.stringify(this.searchValue));
        this.$refs.pagination.resetSize();
        this.$refs.multipleTable.clearSort();
        this.$refs.pagination.handleSizeChange(10);
        this.loadData();
    }

    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.isAsc = true;
        } else {
            this.searchValue.isAsc = false;
        }
        // switch (col.prop) {
        //     case 'creationTime':
        //         {
        //             this.searchValue.orderBy = 1;
        //         }
        //         break;
        // }
        this.loadData();
    }

    public expandType: boolean = false;
    public loading = false;
    public rePagin = false;
    public tabelData = [];
    public total = 20;
    public isActive: boolean = false;

    public tableData: any = [];

    public async loadData() {
        this.loading = true;
        try {
            let res = await Kpi.GetKpiDetailList({
                ...this.searchValue,
                // kpiId: this.KpiId,
                skip: this.searchPagin.skip,
                count: this.searchPagin.count,
            });
            this.tableData = res.data;
            let skip = this.searchPagin.skip;
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.tableData.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
        } catch {
            this.loading = false;
        }
    }

    public created() {}

    public KpiId: any = '';
    public mounted() {
        this.KpiId = this.$route.query.id;

        console.log(' this.KpiId' + this.KpiId);
        if (sessionStorage.getItem('CarrierKPIDetial_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('CarrierKPIDetial_searchValue'));
            this.searchValue.KpiId = this.KpiId;
            this.timeList = [this.searchValue.startTime, this.searchValue.endTime];
            // this.searchPagin = sessionStorage.getItem('CarrierKPIDetial_page')
            //     ? JSON.parse(sessionStorage.getItem('CarrierKPIDetial_page'))
            //     : this.searchPagin;

            this.loadData();
        } else {
            // this.searchPagin = sessionStorage.getItem('CarrierKPIDetial_page')
            //     ? JSON.parse(sessionStorage.getItem('CarrierKPIDetial_page'))
            //     : this.searchPagin;

            this.loadData();
        }
    }

    public getMore() {
        this.expandType = !this.expandType;
    }

    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('CarrierKPIDetial_page', JSON.stringify(pagin));
        this.loadData();
    }

    public formData: any = {
        kpiName: '',
        month: '',
        cycleStart: '',
        cycleEnd: '',
    };
    public title = '新增KPI考核';
    public addNew() {
        this.title = '新增KPI考核';
        this.formData = {
            kpiName: '',
            month: '',
            cycleStart: '',
            cycleEnd: '',
        };
        if (this.$refs.formData) {
            this.$refs.formData.resetFields();
        }
        this.dialogVisible = true;
    }

    public save() {
        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                if (this.title == '新增KPI考核') {
                    await Kpi.AddKpi(this.formData);
                    this.$message.success('新增成功!');
                    this.dialogVisible = false;
                    this.loadData();
                } else {
                    // await ExpenseType.AddOrEdit(this.formData);
                    // this.$message.success('编辑成功!');
                    // this.dialogVisible = false;
                    // this.loadData();
                }
            }
        });
    }

    // public async toEdit(id) {
    //     this.title = '编辑费用类型';
    //     let res = await ExpenseType.GetDetail(id);
    //     this.dialogVisible = true;
    //     this.formData = res;
    //     if (this.$refs.formData) {
    //         this.$refs.formData.resetFields();
    //     }
    // }

    public toDel(id) {
        this.$confirm('确认删除该费用类型?', '删除费用类型', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                Kpi.DelKpi(id).then(() => {
                    this.$message.success('删除成功');
                    this.loadData();
                });
            })
            .catch(() => {});
    }

    /** 新增 */
    public selectedId: any = '';
    public selectionRow = [] as any;

    handleSelectionChange(rows) {
        this.selectionRow = rows; //保存已选择行
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }

    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
}
